import recruitmentService from "@/services/jobOffer";

const API_JOB_OFFER_REDIRECT ='/api/configurations/redirect/';
export default {
    data() {
        return {
            configuration: null,
            idJobOffer: null,
            isShowErrorMessage: false,
            errorMessage: null
        };
      },
      created() {
        this.getJobOfferId()
       
      },
      computed: {
        wid() {
            return this.$route.params.wid;
          },
       },
      methods: {
       getJobOfferId() {
        recruitmentService.getJobOfferID(this.wid).then((res)=> {
            if(res && res.success && res.betweenJobOffer) {
                this.idJobOffer = res.betweenJobOffer.idJobOffer;
                this.isShowErrorMessage = false;
                this.errorMessage = null;
                window.location.replace(API_JOB_OFFER_REDIRECT+this.idJobOffer)
            } else {
                this.isShowErrorMessage = true;
               this.errorMessage = res.err.message;
            }
          
        }).catch((err)=> {
            this.isShowErrorMessage = true;
            this.errorMessage =  this.$t('job-offer-error-message');
        })
       },
      },
}